import { LOCALES, pathFor } from '@nexa/content';
import { Icon } from '@nexa/ui';
import { useCopy, useLocale, usePageId } from '@/core/i18n';

/**
 * Nút đổi ngôn ngữ — pill 34px của thiết kế (`template.html:597`): icon `languages` + mã ngôn
 * ngữ ĐANG XEM. Bản trước của lô 0 render hai liên kết (VI | EN); thiết kế chỉ có một.
 *
 * Là `<a>` thật, KHÔNG phải `<button>` và cũng KHÔNG phải `<Link>` của router.
 *
 * Không `<button>`: đổi ngôn ngữ là điều hướng tới một URL khác, nên nó phải mở được tab mới,
 * copy được địa chỉ, và để Google thấy cặp liên kết chéo ngôn ngữ.
 *
 * Không `<Link>` — đây là chỗ đổi 2026-08-30 và là hệ quả BẮT BUỘC của việc locale chuyển sang
 * query: `/terms/` → `/terms/?lang=en` đổi QUERY mà không đổi path, nên react-router coi là cùng
 * route và không remount ⇒ người bấm sẽ thấy y nguyên ngôn ngữ cũ. Và nội dung bản kia nằm ở một
 * FILE khác (`dist/__lang/en/…`) mà chỉ nginx mới lấy được, nên tải lại document là bắt buộc chứ
 * không phải lựa chọn.
 *
 * Chữ nhìn thấy là locale HIỆN TẠI (đúng thiết kế) trong khi hành động là chuyển sang locale
 * kia — nên `aria-label` phải nói ra hành động, nếu không screen reader đọc thành "liên kết VI"
 * dẫn tới trang tiếng Anh. Mã ngắn suy từ chính `locale`, không thêm khoá copy: `LOCALE_LABEL`
 * là tên đầy đủ ("Tiếng Việt"), dùng nó ở đây thì pill dài gấp ba và vỡ ở 360px.
 *
 * Chuyển ngôn ngữ giữ NGUYÊN trang đang xem (`pathFor(pageId, target)`), không đổ về trang chủ:
 * người đang đọc bảng giá bị đá về trang chủ sẽ bỏ đi, và Google coi cặp hreflang không tương
 * ứng là tín hiệu không nhất quán.
 *
 * Dưới `md` cao 44px (skill luật 6); từ `md` lên giữ đúng 34px của thiết kế.
 */
export function LanguageSwitcher() {
  const currentLocale = useLocale();
  const copy = useCopy();
  const pageId = usePageId() ?? 'home';
  const target = LOCALES.find((locale) => locale !== currentLocale) ?? currentLocale;

  return (
    <a
      href={pathFor(pageId, target)}
      rel="alternate"
      hrefLang={target}
      aria-label={copy.nav.switchTo[target]}
      className="flex min-h-11 items-center gap-1.5 rounded-pill border border-ink-300 bg-surface px-3 text-caption font-semibold tracking-label text-ink-800 transition [transition-duration:var(--duration-hover)] hover:border-brand-600 hover:text-brand-600 md:min-h-[34px]"
    >
      <Icon name="languages" size={14} />
      <span>{currentLocale.toUpperCase()}</span>
    </a>
  );
}
